// extracted by css-extract-rspack-plugin
export default {"wrapper":"_d512c762"};